import React, { useState, useEffect } from "react";
import { FaArrowLeft, FaFileExcel } from "react-icons/fa";
import NavBar from "../components/NavMenu";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

const DetailNewEnrol = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const passedQuarters = location.state?.selectedQuarters || [
    "Q1 2025",
    "Q4 2024",
  ];
  const [selectedQuarters] = useState(passedQuarters);
  const [studentData, setStudentData] = useState([]);

  const parseQuarterYear = (quarterStr) => {
    const [qtr, year] = quarterStr.split(" ");
    return { qtr: parseInt(qtr.replace("Q", "")), year: parseInt(year) };
  };

  useEffect(() => {
    const fetchData = async () => {
      const { qtr, year } = parseQuarterYear(selectedQuarters[0]);
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API}/getNewEnrollmentByStudent2?qtr=${qtr}&year=${year}`
        );
        const current = res.data.current || [];
        setStudentData(current);
      } catch (err) {
        console.error("Failed to fetch new enrolment data", err);
      }
    };
    fetchData();
  }, [selectedQuarters]);

   const handlePrevious = () => {
    const passedQuarters = location.state?.selectedQuarters || [
      "Q1 2025",
      "Q4 2024",
    ];
    const extractedQuarter = parseInt(
      passedQuarters[0].split(" ")[0].replace("Q", "")
    );
    const extractedYear = parseInt(passedQuarters[0].split(" ")[1]);

    navigate("/home", {
      state: {
        view: "new",
        selectedQuarter: extractedQuarter,
        selectedYear: extractedYear,
      },
    });
  };

  return (
    <>
      <NavBar />
      <div
        style={{
          backgroundColor: "#373636",
          margin: 20,
          borderRadius: 10,
          padding: 30,
          minHeight: "calc(100vh - 80px)",
          color: "#fff",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 20,
            flexWrap: "wrap",
            gap: 12,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <FaArrowLeft size={18} onClick={handlePrevious} />
            <h4 style={{ margin: 0 }}>New Enrollment Details</h4>
            <span
              style={{
                background: "#444",
                padding: "6px 12px",
                borderRadius: 8,
                fontSize: 14,
                fontWeight: 500,
              }}
            >
              {selectedQuarters[0]}
            </span>
            <span
              style={{
                background: "#444",
                padding: "6px 12px",
                borderRadius: 8,
                fontSize: 14,
                fontWeight: 500,
              }}
            >
              Total Count: {studentData.length}
            </span>
          </div>
          <button
            onClick={() => console.log("Export to Excel")}
            className="excel-button"
          >
            <FaFileExcel size={18} /> Export to Excel
          </button>
        </div>

        <div style={{ overflowX: "auto", borderRadius: 6 }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              backgroundColor: "#1f1f1f",
              borderRadius: 6,
              overflow: "hidden",
            }}
          >
            <thead style={{ backgroundColor: "#000" }}>
              <tr>
                <th style={thStyle}>NO</th>
                <th style={thStyle}>STUDENT ID</th>
                <th style={thStyle}>NAME</th>
                <th style={thStyle}>COURSE CODE</th>
                <th style={thStyle}>COURSE LEVEL</th>
                <th style={thStyle}>STUDY MODE</th>
                <th style={thStyle}>FACULTY</th>
                <th style={thStyle}>SBU</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(
                studentData.reduce((acc, item) => {
                  const level = item.course_level || "Unknown Level";
                  if (!acc[level]) acc[level] = [];
                  acc[level].push(item);
                  return acc;
                }, {})
              )
                .sort(([a], [b]) => a.localeCompare(b))
                .map(([level, students], levelIndex) => (
                  <React.Fragment key={levelIndex}>
                    <tr>
                      <td
                        colSpan={8}
                        style={{ ...groupHeaderStyle, padding: "10px 16px" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <span>{level}</span>
                          <span
                            style={{
                              backgroundColor: "#ffa726",
                              padding: "4px 10px",
                              borderRadius: "999px",
                              fontSize: 13,
                              fontWeight: 500,
                              color: "#000",
                              minWidth: 28,
                              textAlign: "center",
                            }}
                          >
                            {students.length}
                          </span>
                        </div>
                      </td>
                    </tr>
                    {students.map((row, idx) => (
                      <tr
                        key={idx}
                        style={{
                          borderTop: "1px solid #444",
                          backgroundColor:
                            idx % 2 === 0 ? "#2b2b2b" : "#252525",
                        }}
                      >
                        <td style={tdStyle}>{idx + 1}</td>
                        <td style={tdStyle}>{row.student_id}</td>
                        <td style={tdStyle}>{row.name}</td>
                        <td style={tdStyle}>{row.course_code}</td>
                        <td style={tdStyle}>{row.course_level}</td>
                        <td style={tdStyle}>{row.study_mode}</td>
                        <td style={tdStyle}>{row.faculty_name}</td>
                        <td style={tdStyle}>{row.sbu_name}</td>
                      </tr>
                    ))}
                  </React.Fragment>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

const thStyle = {
  padding: "14px 12px",
  fontWeight: "bold",
  fontSize: 15,
  color: "#fff",
  borderBottom: "1px solid #444",
  textAlign: "center",
};
const tdStyle = {
  padding: "12px 12px",
  color: "#ddd",
  fontSize: 14,
  textAlign: "center",
};
const groupHeaderStyle = {
  backgroundColor: "#111",
  fontWeight: "bold",
  color: "#fff",
  padding: "10px 12px",
  textAlign: "left",
};

export default DetailNewEnrol;
